// @ts-strict-ignore
import styled from "styled-components";

export const AssetContainer = styled.div`
  padding: 16px 0px;
  margin: 0 -16px;
  img,
  video {
    width: 100%;
  }

  ${({ theme }) => theme.media.tablet`
    padding: 32px 0px;
    margin: 0;
  `}
`;
